import { render, staticRenderFns } from "./StoreReportsCRMReports.vue?vue&type=template&id=4a9a1d8a&scoped=true"
import script from "./StoreReportsCRMReports.vue?vue&type=script&lang=js"
export * from "./StoreReportsCRMReports.vue?vue&type=script&lang=js"
import style0 from "./StoreReportsCRMReports.vue?vue&type=style&index=0&id=4a9a1d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9a1d8a",
  null
  
)

export default component.exports